import config from "../../config.json";
import { reportApiError, reportFailedBody } from "../errors/presentError";
const BASE_AUTH_API = config.BASE_AUTH_API;

// `lang` ("ar" | "en") is optional; without it every video is returned.
export const fetchVideosAPI = async (token, lang) => {
  let responseData;
  const query = lang ? `?lang=${encodeURIComponent(lang)}` : "";
  try {
    await fetch(`${BASE_AUTH_API}videos${query}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.videos;
    }

    return [];
  } catch (error) {
    reportApiError(error);
    return [];
  }
};

export const uploadVideoAPI = async (token, data) => {
  let responseData;

  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("lang", data.lang || "ar");
  // Empty list = visible to all roles.
  formData.append("access", JSON.stringify(data.access || []));
  // Optional: no section means Uncategorized.
  if (data.section) formData.append("section", data.section);
  formData.append("video", data.video);

  try {
    await fetch(`${BASE_AUTH_API}videos/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.video;
    }

    reportFailedBody(responseData);
    return;
  } catch (error) {
    reportApiError(error);
    return;
  }
};

export const updateVideoAPI = async (token, id, changes) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}videos/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(changes),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.video;
    }

    reportFailedBody(responseData);
    return;
  } catch (error) {
    reportApiError(error);
    return;
  }
};

export const deleteVideoAPI = async (token, id) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}videos/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return true;
    }

    return false;
  } catch (error) {
    reportApiError(error);
    return false;
  }
};
// ---- Guideline video sections ------------------------------------------------------------------------------------
const sectionRequest = async (path, { method = "GET", token, body, failure = "Request failed" }) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}videos/sections${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) return responseData;

    reportFailedBody(responseData);
    return;
  } catch (error) {
    reportApiError(error);
    return;
  }
};

export const fetchVideoSectionsAPI = async (token) => {
  try {
    const response = await fetch(`${BASE_AUTH_API}videos/sections`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    return data.success ? data.sections : [];
  } catch (error) {
    reportApiError(error);
    return [];
  }
};

export const createVideoSectionAPI = async (token, data) =>
  (await sectionRequest("", { method: "POST", token, body: data, failure: "Could not create section" }))?.section;

export const updateVideoSectionAPI = async (token, id, changes) =>
  (await sectionRequest(`/${id}`, { method: "PATCH", token, body: changes, failure: "Could not update section" }))?.section;

export const deleteVideoSectionAPI = async (token, id) =>
  Boolean(await sectionRequest(`/${id}`, { method: "DELETE", token, failure: "Could not delete section" }));

// `ids` lists every section in the new order; resolves to the saved list.
export const reorderVideoSectionsAPI = async (token, ids) =>
  (await sectionRequest("/order", { method: "PUT", token, body: { ids }, failure: "Could not reorder sections" }))?.sections;
